import { actionTypes } from 'actions/actionTypes'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const setCardProvider: CheckoutActionCreator = (provider) => ({
  type: actionTypes.PAYMENT_SET_CARD_PROVIDER,
  provider,
})
